<template>
  <CModal alignment="center" :visible="show" @close="$emit('close')">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">設定數字拖曳區間</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div class="options-box">
        您可以設定的最大、最小值等資訊。
        <div
          v-for="item in interval"
          :key="item"
          class="d-flex flex-column mt-3"
        >
          {{ item.label }}
          <input
            v-model="item.value"
            type="number"
            class="ms-0 me-3 content rounded ps-2"
          />
        </div>
      </div>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">完成</CButton>
      <CButton color="light" @click="$emit('close')"> 取消 </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { ref } from '@vue/reactivity'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  emits: ['close', 'interval'],
  setup(props, { emit }) {
    const interval = ref([
      { label: '最小值', value: props.min },
      { label: '最大值', value: props.max },
      // { label: '拖曳的間隔（不設定請留空）', value: '' },
    ])

    const submit = () => {
      emit('interval', interval.value)
      emit('close')
    }
    return { interval, submit }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 300px;
  overflow: scroll;
}
</style>
